import { connect } from 'react-redux'
import SummariesList from '../components/summaries_list'
import { selectEnabledSummaryKeys } from '../selectors'

const mapStateToProps = (state) => ({
  enabledKeys: selectEnabledSummaryKeys(state),
})

export default connect(mapStateToProps)(SummariesList)
